import { Loader2 } from 'lucide-preact';

export function StatusBar() {
  return (
    <div className='flex items-center gap-2 rounded-full bg-[#9c70ff0d] px-2 py-1'>
      <Loader2 className='size-2.5 animate-spin' />
      <span className='align-middle text-[11px] font-medium leading-[18px] text-[#9c70ff]'>
        Proces učení zabere 1-3 minuty
      </span>
    </div>
  );
}
